import React from 'react';
import Card from '../../../../muiComponents/Card';
import Label from '../Label';
import Tag from '../../../../muiComponents/Tag';
import {
    ComplementaryServiceTypeState,
    ServiceState,
} from '../../../../types/properties/propertyTypes';

interface ServicesSectionProps {
    title: string;
    servicesList: ComplementaryServiceTypeState[] | ServiceState[];
    color: string;
    onClickService: (collectionKey: 'services', service: ServiceState) => void;
    selectedServices: ServiceState[];
}

const ServicesSection = ({
    title,
    servicesList,
    color,
    onClickService,
    selectedServices,
}: ServicesSectionProps) => {
    const getIsServiceSelected = (serviceId: string) => {
        return selectedServices
            .filter(selectedService => !selectedService.Deleted)
            .some(selectedService => selectedService.id === serviceId);
    };

    return (
        <>
            {servicesList.length ? (
                <Card className='flex-column flex-center gap-20 padding20'>
                    <Label
                        text={title}
                        translated={true}
                        className='text-align-center'
                    />
                    <div className='flex flex-wrap flex-center gap-20'>
                        {servicesList.map(service => {
                            const isSelected = getIsServiceSelected(service.id);

                            return (
                                <Tag
                                    button
                                    key={service.id}
                                    className={`tag-button__${color}${
                                        isSelected ? '--checked' : ''
                                    }`}
                                    text={service.name}
                                    onClick={() =>
                                        onClickService('services', {
                                            id: service.id,
                                            name: service.name,
                                            free: service.free,
                                        })
                                    }
                                />
                            );
                        })}
                    </div>
                </Card>
            ) : (
                ''
            )}
        </>
    );
};

export default ServicesSection;
